/**
 * License Intelligence SAP Licence Inventory Mock Data
 *
 * Mock data for the licence inventory API endpoint.
 * In production, this data will come from:
 * GET /ECMv6/api/sodms/license-intelligence/v1/sap/overview/licence-inventory
 */

export interface LicenceInventoryTier {
  tier: string;
  unitWeight: number;
  userCount: number;
  consumedUnit: number;
  contractedUnit: number;
  annualCost: number;
  displayCost: string;
  utilization: number;
  threshold: string;
  contractExpiry: string;
  expiryWarning: string | null;
}

export interface LicenceInventoryData {
  totalAnnualCost: {
    value: number;
    displayValue: string;
  };
  summary: string;
  tiers: LicenceInventoryTier[];
  defaultMode: boolean;
}

export interface LicenceInventoryResponse {
  data: LicenceInventoryData;
  status: number;
  message: string;
}

export const LICENSE_INTELLIGENCE_LICENCE_INVENTORY_DATA: LicenceInventoryResponse =
  {
    data: {
      totalAnnualCost: {
        value: 4400000,
        displayValue: '$4.4M/yr',
      },
      summary: '4 Active Tiers • 98.8K Identities • 81% Utilization',
      tiers: [
        {
          tier: 'Self-Service',
          unitWeight: 0.033,
          userCount: 95200,
          consumedUnit: 3141.6,
          contractedUnit: 3400,
          annualCost: 3015936,
          displayCost: '$3.0M',
          utilization: 92.4,
          threshold: '80',
          contractExpiry: '2027-12-31',
          expiryWarning: null,
        },
        {
          tier: 'Advanced',
          unitWeight: 1.0,
          userCount: 680,
          consumedUnit: 680.0,
          contractedUnit: 1500,
          annualCost: 652800,
          displayCost: '$653k',
          utilization: 45.3,
          threshold: '80',
          contractExpiry: '2027-12-31',
          expiryWarning: null,
        },
        {
          tier: 'Developer',
          unitWeight: 0.5,
          userCount: 50,
          consumedUnit: 25.0,
          contractedUnit: 200,
          annualCost: 24000,
          displayCost: '$24k',
          utilization: 12.5,
          threshold: '80',
          contractExpiry: '2027-12-31',
          expiryWarning: null,
        },
        {
          tier: 'Core',
          unitWeight: 0.2,
          userCount: 2870,
          consumedUnit: 0.4,
          contractedUnit: 1500,
          annualCost: 384,
          displayCost: '$384',
          utilization: 0.03,
          threshold: '80',
          contractExpiry: '2027-12-31',
          expiryWarning: null,
        },
      ],
      defaultMode: false,
    },
    status: 200,
    message: 'Licence inventory data retrieved successfully',
  };

export default LICENSE_INTELLIGENCE_LICENCE_INVENTORY_DATA;
